import React from "react";
import "./latestjob.css";
import Arrow1 from "./Arrow1.png";
import Location from "./location.png";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
const Latestjob = (props) => {
  console.log("data", props.data);
  const navigate = useNavigate();

  const handleClick = () => {
    // Navigate to a specific route
    navigate(`/jobs/cv/${props.data.job_id}`, { state: { data: props.data } }); // Replace '/home' with the desired route
  };
  return (
    <>
      <div className="latestJobContainer">
        <div className="latestjobTitle">{props.JobTitle}</div>
        <div className="latestJoblocation">
          <img src={Location} alt="Location" />
          {props.Location}
        </div>
        <div className="latestJobapply">
          <button onClick={handleClick}>
            Apply <img src={Arrow1} alt="Arrow" />
          </button>
        </div>
      </div>
      <hr />
    </>
  );
};

export default Latestjob;
